<section class="user-manual mb-4 text-center">
  <a href="assets/document/Manual_E-TA_2019.pdf" download>{{ 'userManual' | translate }}</a>
</section>
